import { render, staticRenderFns } from "./Photos.vue?vue&type=template&id=5bde41a0&scoped=true&"
import script from "./Photos.vue?vue&type=script&lang=ts&"
export * from "./Photos.vue?vue&type=script&lang=ts&"
import style0 from "./Photos.vue?vue&type=style&index=0&id=5bde41a0&prod&lang=scss&scoped=true&"
import style1 from "./Photos.vue?vue&type=style&index=1&id=5bde41a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bde41a0",
  null
  
)

export default component.exports